import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Collapse,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Fab,
  fade,
  FormControlLabel,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextareaAutosize,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import {
  Warning,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Add,
  MoreVert,
  Edit,
  Check,
} from "@material-ui/icons";
import Title from "../../ui/Title";
import { addMonths, format, parse } from "date-fns";
import {
  RESERVATIONS_STATUS,
  RESERVATIONS_VISITOR_TYPES_RESTRICTED,
  RESERVATIONS_VISIT_LANGUAGES,
} from "../../utils/ecommerceGenConstants";
import { ecommerce } from "../../messages/ecommerce";
import { form } from "../../messages/form";
import { useIntl } from "react-intl";
import { DatePicker, TimePicker } from "../../ui/DatePicker";
import { common } from "../../messages";
import { it } from "date-fns/locale";
import { useBmapi } from "../../utils/bmapi-context";
import { getStatusLabel } from "../../utils/ecommerceUtils";
import { getErrorMessageString } from "../../utils/errors";
import FloatingActions from "../../ui/FloatingActions";

const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
  cardActionsRight: {
    justifyContent: "flex-end",
    marginTop: "1rem",
  },
  headerCheckbox: {
    padding: 0,
  },
  rowCheckbox: {},
  rightSpacer: {
    marginRight: theme.spacing(2),
  },
  rowToBeConfirmed: {
    backgroundColor: fade(theme.palette.primary.main, 0.2),
  },
  colNotSortable: {
    backgroundColor: "#f8f3f4",
  },
}));

export default function ManageReservationsGen() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  /*
  const byDate = (a, b) => {
    const todayString = new Date().toISOString().slice(0, 10).replace(/-/g, "");
    const dateA = Number(a.date);
    const dateB = Number(b.date);

    const isFutureA = dateA >= Number(todayString);
    const isFutureB = dateB >= Number(todayString);

    if (isFutureA !== isFutureB) {
      return isFutureA ? -1 : 1;
    }

    return dateA - dateB;
  };
  */
  const [sortConfig, setSortConfig] = useState({
    key: "date",
    direction: "asc",
  });
  const sortBy = (key) => {
    setSortConfig((current) => ({
      key,
      direction:
        current.key === key && current.direction === "asc" ? "desc" : "asc",
    }));
  };

  const classes = useRowStyles();
  const intl = useIntl();
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const {
    bmapi,
    startLoading,
    stopLoading,
    notifyError,
    notifyDialog,
    hideDialog,
    notifySuccess,
  } = useBmapi();

  const [openRows, setOpenRows] = useState([]);
  const [openNotes, setOpenNotes] = useState([]);
  const [open, setOpen] = useState(false);
  const [closingDates, setClosingDates] = useState([]);
  const [reservations, setReservations] = useState([]);
  //const [filteredReservations, setFilteredReservations] = useState([]);
  //const [reservationAvailableDays, setReservationAvailableDays] = useState([]);
  const [notAvailableDays, setNotAvailableDays] = useState([]);
  const [reservationAvailableSlot, setReservationAvailableSlot] = useState([]);
  const [selection, setSelection] = useState([]);
  const [provinces, setProvinces] = useState({});
  const [countries, setCountries] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [reservationSelected, setReservationSelected] = React.useState(null);

  const initialValues = () => ({
    id: null,
    period_date: null,
    period: null,
    first_name: null,
    last_name: null,
    email: null,
    mobile: null,
    notes: null,
    country: null,
    arrival_time: null,
    attrs: [],
  });
  const [values, setValues] = useState(initialValues());
  const { period_date, country } = values;

  const initFilters = {
    from: new Date(),
    fromStr: null,
    to: addMonths(new Date(), 12),
    created_at_from: null,
    created_at_to: null,
    toStr: null,
    status: "x",
    referrer: "",
    visitorType_filter: "",
    country: "",
    region: "",
    province: "",
  };
  const initCleanFilters = {
    from: null,
    fromStr: null,
    to: null,
    toStr: null,
    created_at_from: null,
    created_at_to: null,
    status: "x",
    referrer: "",
    visitorType_filter: "",
    country: "",
    region: "",
    province: "",
  };

  const [filters, setFilters] = useState(initFilters);

  const handleValue = useCallback((label) => {
    const updateValue = (val) => {
      setValues((v) => ({ ...v, [label]: val }));
    };

    return (i, f) => {
      if (typeof f === "boolean") updateValue(f);
      else if (i?.target) updateValue(i.target.value);
      else updateValue(i);
    };
  }, []);

  const handleClick = (event, reservation) => {
    setAnchorEl(event.currentTarget);
    setReservationSelected(reservation);
  };

  const businessID = bmapi.getUserInfo().business.id;

  const getFiltersParam = (filters) => {
    const filtersParam = {};
    if (
      filters.status !== null &&
      filters.status !== "" &&
      filters.status !== "x"
    ) {
      filtersParam["status"] = filters.status;
    }
    if (filters.from != null) {
      filtersParam["order_date_from"] = format(filters.from, "dd-MM-yyyy");
    }
    if (filters.to != null) {
      filtersParam["order_date_to"] = format(filters.to, "dd-MM-yyyy");
    }
    if (filters.created_at_from != null) {
      filtersParam["from"] = format(filters.created_at_from, "dd-MM-yyyy");
    }
    if (filters.created_at_to != null) {
      filtersParam["to"] = format(filters.created_at_to, "dd-MM-yyyy");
    }
    if (filters.referrer != null) {
      filtersParam["referrer"] = filters.referrer;
    }
    if (filters.country != "" && filters.country != null) {
      filtersParam["attrs.country"] = filters.country;
    }
    if (filters.region != "" && filters.region != null) {
      filtersParam["attrs.region"] = filters.region;
    }
    if (filters.province != "" && filters.province != null) {
      filtersParam["attrs.province"] = filters.province;
    }
    if (
      filters.visitorType_filter != "" &&
      filters.visitorType_filter != null
    ) {
      filtersParam["attrs.group_type"] = filters.visitorType_filter;
    }

    return filtersParam;
  };

  const loadReservationList = useCallback(
    async (filters = null) => {
      let filtersParam;
      if (filters != null) {
        filtersParam = getFiltersParam(filters);
      }

      startLoading();

      try {
        const resp = await bmapi.getEOrder({
          business: bmapi.getUserInfo().business.id,
          decode_user: true,
          ...filtersParam,
        });

        setReservations(resp || []);
        setSelection([]);
      } catch (e) {
        notifyError(getErrorMessageString(e, intl));
      } finally {
        stopLoading();
      }
    },
    [bmapi, intl, notifyError, startLoading, stopLoading]
  );

  useEffect(() => {
    bmapi.getBusiness(businessID).then((resp) => {
      setClosingDates(resp?.closing_dates || []);
    });

    getProvinces();
    getCountries();
    loadReservationList(filters);
  }, [bmapi, businessID, loadReservationList]);

  useEffect(() => {
    if (period_date != null) {
      setReservationAvailableSlot([]);
      doSearch();
    }
  }, [period_date]);

  useEffect(() => {
    if (country != "it") {
      cleanCountryData();
    }
  }, [country]);

  useEffect(() => {
    if (filters.country != "it") {
      cleanFilterCountryData();
    }
  }, [filters.country]);

  useEffect(() => {
    getAvailableDays();
  }, []);

  const searchReservations = useCallback(() => {
    loadReservationList(filters);
  }, [filters]);

  const cleanFilters = useCallback(() => {
    setFilters(initCleanFilters);
    loadReservationList();
  }, [setFilters, filters]);

  const toggleSelectionAll = useCallback(
    (checked) => {
      setSelection(checked ? reservations : []);
    },
    [reservations]
  );

  const handleFilters = useCallback((label) => {
    const updateValue = (val) => {
      let newVal = val;

      if (label === "from" || label === "to") {
        if (val) {
          newVal = new Date(val);
          newVal.setHours(0, 0, 0, 0);
        }
      }

      if (label === "from") {
        const fromStr = newVal ? newVal.toISOString() : null;

        setFilters((v) => ({
          ...v,
          from: newVal,
          fromStr,
        }));
      } else if (label === "to") {
        let toStr = null;

        if (newVal) {
          const toAfter = new Date(newVal);
          toAfter.setDate(toAfter.getDate() + 1);
          toStr = toAfter.toISOString();
        }

        setFilters((v) => ({
          ...v,
          to: newVal,
          toStr,
        }));
      } else {
        setFilters((v) => ({
          ...v,
          [label]: newVal,
        }));
      }
    };

    return (i, f) => {
      if (typeof f === "boolean") updateValue(f);
      else if (i?.target) updateValue(i.target.value);
      else updateValue(i);
    };
  }, []);

  const handleSelection = useCallback((reservation) => {
    setSelection((currentSelection) => {
      const selectedIndex = currentSelection.findIndex(
        (selected) => selected.id === reservation.id
      );

      if (selectedIndex === -1) {
        return [...currentSelection, reservation];
      }

      return currentSelection.filter((item) => item.id !== reservation.id);
    });
  }, []);

  const handleToggleRow = useCallback((index) => {
    setOpenRows((current) => {
      const newOpenRows = [...current];
      newOpenRows[index] = !newOpenRows[index];
      return newOpenRows;
    });
  }, []);

  const handleToggleNotes = useCallback((index) => {
    setOpenNotes((current) => {
      const newOpenNotes = [...current];
      newOpenNotes[index] = !newOpenNotes[index];
      return newOpenNotes;
    });
  }, []);

  const checkClosingDates = useCallback(
    (date) => {
      const currentDateFormatted = format(new Date(date), "yyyyMMdd");

      const directMatch = closingDates.includes(currentDateFormatted);
      if (directMatch) return true;

      return closingDates.some((d) => {
        if (d.includes("-")) {
          const [start, end] = d.split("-");
          return currentDateFormatted >= start && currentDateFormatted <= end;
        }

        return false;
      });
    },
    [closingDates]
  );

  const getAttributesMap = (reservation) => {
    const attributesMap = {};

    if (reservation.attrs && Array.isArray(reservation.attrs)) {
      reservation.attrs.forEach((attr) => {
        if (attr.key && attr.value) {
          attributesMap[attr.key] = attr.value;
        }
      });
    }

    return attributesMap;
  };

  const filterStatus = (status) => (item) => item.status === status;

  const confirmReservations = async (reservationsToConfirm) => {
    const ordersStatus = reservationsToConfirm.map((r) => ({
      id: r.id,
      status: 2,
    }));

    try {
      startLoading();
      await bmapi.updateOrdersListStatus(ordersStatus);
      hideDialog();
      loadReservationList(filters);
    } catch (e) {
      hideDialog();
      notifyError(getErrorMessageString(e, intl));
    } finally {
      stopLoading();
    }
  };

  const askConfirmReservations = () => {
    const toConfirm = selection.length
      ? selection.filter(filterStatus(0))
      : [reservationSelected];

    if (!toConfirm?.length) {
      notifyError(
        intl.formatMessage(ecommerce.noSelectedReservationsToConfirm)
      );
      return;
    }

    notifyDialog({
      text:
        toConfirm.length === 1
          ? intl.formatMessage(ecommerce.askConfirm1Reservation)
          : intl.formatMessage(ecommerce.askConfirmNReservations, {
              numReservations: toConfirm.length,
            }),
      title: intl.formatMessage(common.confirm),
      actions: [
        {
          text: intl.formatMessage(common.proceed),
          variant: "contained",
          color: "primary",
          onClick: () => confirmReservations(toConfirm),
        },
      ],
    });
  };

  const cancelReservations = async (reservationsToCancel) => {
    const ordersStatus = reservationsToCancel.map((r) => ({
      id: r.id,
      status: 0,
    }));

    try {
      startLoading();
      await bmapi.updateOrdersListStatus(ordersStatus);
      hideDialog();
      loadReservationList(filters);
    } catch (e) {
      hideDialog();
      notifyError(getErrorMessageString(e, intl));
    } finally {
      stopLoading();
    }
  };

  const askCancelReservations = () => {
    const toCancel = selection.filter(filterStatus(2));

    if (!toCancel?.length) {
      notifyError(intl.formatMessage(ecommerce.noSelectedReservationsToCancel));
      return;
    }

    notifyDialog({
      text:
        toCancel.length === 1
          ? intl.formatMessage(ecommerce.askCancel1Reservation)
          : intl.formatMessage(ecommerce.askCancelNReservations, {
              numReservations: toCancel.length,
            }),
      title: intl.formatMessage(common.cancel),
      actions: [
        {
          text: intl.formatMessage(common.proceed),
          variant: "contained",
          color: "primary",
          onClick: () => cancelReservations(toCancel),
        },
      ],
    });
  };

  const renderReservationDetails = (r) => {
    const attrs = getAttributesMap(r);

    const _visitorType =
      RESERVATIONS_VISITOR_TYPES_RESTRICTED[attrs["group_type"]];
    let visitorType = "";

    if (_visitorType) {
      try {
        visitorType = intl.formatMessage(_visitorType);
      } catch (e) {
        visitorType = _visitorType;
      }
    }

    const _visitLang = RESERVATIONS_VISIT_LANGUAGES[attrs["visit_lang"]];
    let visitLang = "";

    if (_visitLang) {
      try {
        visitLang = intl.formatMessage(_visitLang);
      } catch (e) {
        visitLang = _visitLang;
      }
    }

    return {
      attrs,
      visitorType,
      visitLang,
    };
  };

  const getAttrs = () => {
    const attrs = [];
    if (values.visitorType) {
      attrs.push({ key: "group_type", value: values.visitorType });
    }
    if (values.visitorGroupName) {
      attrs.push({ key: "group_name", value: values.visitorGroupName });
    }
    if (values.participantsNumber) {
      attrs.push({ key: "group_number", value: values.participantsNumber });
    }
    if (values.language) {
      attrs.push({ key: "visit_lang", value: values.language });
    }
    if (values.pullman_length) {
      attrs.push({ key: "pullman_length", value: values.pullman_length });
    }
    if (values.pullman_number) {
      attrs.push({ key: "pullman_number", value: values.pullman_number });
    }
    if (values.arrival_time != "" && values.arrival_time != null) {
      attrs.push({
        key: "arrival_time",
        value: format(values.arrival_time, "HH:mm"),
      });
    }
    if (values.survivor) {
      attrs.push({ key: "survivor", value: values.survivor ? "true" : "" });
    }
    if (values.country) {
      attrs.push({ key: "country", value: values.country });
    }
    if (values.region) {
      attrs.push({ key: "region", value: values.region });
    }
    if (values.province) {
      attrs.push({ key: "province", value: values.province });
    }
    if (values.city) {
      attrs.push({ key: "city", value: values.city });
    }
    return attrs;
  };

  const addReservations = () => {
    const data = {
      first_name: "fn",
      last_name: "ln",
      content_id: "default",
      date: format(values.period_date, "yyyy-MM-dd"),
      slot_id: values.period,
      mobile: values.mobile,
      email: bmapi.getUserInfo().email,
      notes: values.notes,
      status: values.to_confirm ? 0 : 2,
      referrer: values.referrer_person,
      attrs: getAttrs(),
    };
    bmapi
      .createEOrderAdmin(data)
      .then(() => {
        setOpen(false);
        loadReservationList(filters);
        notifySuccess(intl.formatMessage(common.addElement));
      })
      .catch((e) => {
        notifyError(getErrorMessageString(e, intl));
      })
      .finally(() => {
        stopLoading();
      });
  };

  const editReservations = () => {
    const data = {
      id: values.id,
      first_name: "fn",
      last_name: "ln",
      content_id: "default",
      date: format(values.period_date, "yyyy-MM-dd"),
      slot_id: values.period,
      mobile: values.mobile,
      email: bmapi.getUserInfo().email,
      notes: values.notes,
      referrer: values.referrer_person,
      attrs: getAttrs(),
    };
    bmapi
      .updateOrderAdmin(data)
      .then(() => {
        setOpen(false);
        loadReservationList(filters);
        notifySuccess(intl.formatMessage(common.editElement));
      })
      .catch((e) => {
        notifyError(getErrorMessageString(e, intl));
      })
      .finally(() => {
        stopLoading();
      });
  };

  const formatDate = (date) => {
    const strDate = `${date.day}-${date.month}-${date.year}`;
    const partialDate = strDate.split("-");
    const formattedDate = new Date(
      partialDate[2],
      partialDate[1] - 1, // index -1 for months
      partialDate[0]
    );
    return format(formattedDate, "yyyy-MM-dd");
  };

  const getAvailableDays = () => {
    const d = new Date();
    const from = format(d, "yyyy-MM-dd");
    const to = format(d.setFullYear(d.getFullYear() + 1), "yyyy-MM-dd");

    if (bmapi) {
      bmapi
        .getRevervationAvailableDays(
          {
            business: businessID,
          },
          {
            from: from,
            to: to,
          }
        )
        .then((resp) => {
          if (!resp) {
            resp = [];
          }
          const notAvailable = resp
            .filter((r) => r.status !== "AVAILABLE")
            .map((date) => formatDate(date));
          setNotAvailableDays(notAvailable);
          //setReservationAvailableDays(resp);
        })
        .catch((e) => {
          notifyError(getErrorMessageString(e, intl));
        });
    }
  };

  const doSearch = () => {
    const date = format(values.period_date, "yyyy-MM-dd");
    if (values.id == "") {
      removePeriod();
    }

    if (bmapi) {
      bmapi
        .getRevervationAvailableSlot({
          business: businessID,
          date: date,
        })
        .then((resp) => {
          if (!resp) {
            resp = [];
          }
          setReservationAvailableSlot(resp);
        })
        .catch((e) => {
          notifyError(getErrorMessageString(e, intl));
        });
    }
  };

  const getProvinces = () => {
    if (bmapi) {
      bmapi
        .getProvinces()
        .then((resp) => {
          if (!resp) {
            resp = [];
          }
          setProvinces(resp);
        })
        .catch((e) => {
          notifyError(getErrorMessageString(e, intl));
        });
    }
  };

  const getCountries = () => {
    const userLang = bmapi.language != "it" ? "en" : "it";
    if (bmapi) {
      bmapi
        .getCountries({
          language: userLang,
        })
        .then((resp) => {
          if (!resp) {
            resp = [];
          } else {
            resp = resp.items;
          }

          setCountries(resp);
        })
        .catch((e) => {
          notifyError(getErrorMessageString(e, intl));
        });
    }
  };

  const cleanCountryData = () => {
    const newValues = { ...values };
    newValues.region = null;
    newValues.province = null;
    setValues(newValues);
  };

  const cleanFilterCountryData = () => {
    const newValues = { ...filters };
    newValues.region = null;
    newValues.province = null;
    setFilters(newValues);
  };

  const removePeriod = () => {
    const newValues = { ...values };
    newValues.period = null;
    setValues(newValues);
  };

  const selectPeriod = (p) => {
    const newValues = { ...values };
    newValues.period = p?.inner_slot_id;
    setValues(newValues);
  };

  const getCountryLabel = (country) => {
    const countrySel = countries.find((item) => item.id == country);
    return countrySel?.str_value;
  };

  const getSurvirorLabel = (survivor) => {
    return survivor
      ? intl.formatMessage(common.yes)
      : intl.formatMessage(common.no);
  };

  const formatArrivalTime = (hhmm) => {
    if (hhmm == undefined || hhmm == "") {
      return null;
    }
    const date = parse(hhmm, "HH:mm", new Date());
    return date;
  };

  const setEditReservations = (r) => {
    let dataStr = r.date;
    dataStr = dataStr != "" ? dataStr : format(new Date(), "yyyy-MM-dd");
    const anno = parseInt(dataStr.substring(0, 4), 10);
    const mese = parseInt(dataStr.substring(4, 6), 10) - 1;
    const giorno = parseInt(dataStr.substring(6, 8), 10);
    const data = new Date(anno, mese, giorno);
    const attrs = getAttributesMap(r);

    setOpen(true);

    const newValues = { ...values };
    newValues.id = r.id;
    newValues.period_date = data;
    newValues.period = r.slot_id;
    newValues.first_name = r.first_name;
    newValues.last_name = r.last_name;
    newValues.email = r.email;
    newValues.mobile = r.mobile;
    newValues.notes = r.notes;
    newValues.referrer_person = r.referrer;
    newValues.arrival_time = formatArrivalTime(attrs["arrival_time"]);
    newValues.visitorType = attrs["group_type"];
    newValues.visitorGroupName = attrs["group_name"];
    newValues.participantsNumber = attrs["group_number"];
    newValues.language = attrs["visit_lang"];
    newValues.country = attrs["country"];
    newValues.region = attrs["region"];
    newValues.province = attrs["province"];
    newValues.city = attrs["city"];
    newValues.pullman_number = attrs["pullman_number"];
    newValues.pullman_length = attrs["pullman_length"];
    newValues.survivor = attrs["survivor"];
    setValues(newValues);
  };

  const openAddModal = () => {
    setOpen(true);
    setReservationAvailableSlot([]);
    setValues(initialValues);
  };

  const minDate = format(new Date(), "yyyy-MM-dd");

  const sortedReservations = [...reservations].sort((a, b) => {
    const valoreA = a[sortConfig.key];
    const valoreB = b[sortConfig.key];

    if (typeof valoreA === "string") {
      return sortConfig.direction === "asc"
        ? valoreA.localeCompare(valoreB)
        : valoreB.localeCompare(valoreA);
    }

    return sortConfig.direction === "asc"
      ? valoreA - valoreB
      : valoreB - valoreA;
  });

  function getSortIcon(field) {
    return (
      <span style={{ fontSize: "18px" }}>
        {sortConfig.key === field &&
          (sortConfig.direction === "asc" ? "↑" : "↓")}
      </span>
    );
  }
  return (
    <Container maxWidth="lg">
      <Title>{intl.formatMessage(ecommerce.reservationsDone)}</Title>

      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          {intl.formatMessage(values.id == null ? common.add : common.modify)}
        </DialogTitle>
        <form>
          <DialogContent>
            <DatePicker
              style={{ marginTop: 0 }}
              label={intl.formatMessage(common.date)}
              inputFormat="dd/MM/yyyy"
              value={values.period_date}
              onChange={handleValue("period_date")}
              format="dd/MM/yy"
              minDate={minDate}
              shouldDisableDate={(date) =>
                notAvailableDays.includes(format(date, "yyyy-MM-dd"))
              }
            />

            <Box style={{ marginTop: "10px" }}>
              {reservationAvailableSlot?.map((t) => (
                <Button
                  variant={
                    t.inner_slot_id == values.period ? "contained" : "outlined"
                  }
                  key={t.day}
                  style={{ marginRight: "10px" }}
                  onClick={() => {
                    selectPeriod(t);
                  }}
                >
                  {`${t.start.substring(0, 2)}:${t.start.substring(
                    2
                  )} - ${t.end.substring(0, 2)}:${t.end.substring(2)}`}
                </Button>
              ))}
            </Box>

            {values.period != null ? (
              <Box>
                <TextField
                  margin="normal"
                  fullWidth
                  label={intl.formatMessage(ecommerce.visitorGroupName)}
                  onChange={handleValue("visitorGroupName")}
                  value={values.visitorGroupName}
                />
                <TextField
                  margin="dense"
                  value={values.visitorType}
                  fullWidth
                  onChange={handleValue("visitorType")}
                  label={intl.formatMessage(ecommerce.visitorType)}
                  select
                >
                  {Object.entries(RESERVATIONS_VISITOR_TYPES_RESTRICTED).map(
                    ([key, value]) => (
                      <MenuItem key={key} value={key}>
                        {intl.formatMessage(value)}
                      </MenuItem>
                    )
                  )}
                </TextField>

                <TextField
                  margin="dense"
                  value={values.language}
                  fullWidth
                  onChange={handleValue("language")}
                  label={intl.formatMessage(ecommerce.visitLanguage)}
                  select
                >
                  {Object.entries(RESERVATIONS_VISIT_LANGUAGES).map(
                    ([key, value]) => (
                      <MenuItem key={key} value={key}>
                        {intl.formatMessage(value)}
                      </MenuItem>
                    )
                  )}
                </TextField>

                <Box>
                  <TextField
                    style={{ width: "25%" }}
                    margin="dense"
                    value={values.country}
                    onChange={handleValue("country")}
                    label={intl.formatMessage(common.country)}
                    select
                  >
                    <MenuItem key="country-empty" value="">
                      -
                    </MenuItem>
                    {countries?.sort().map((c) => (
                      <MenuItem key={c.id} value={c.id}>
                        {c.str_value}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    style={{ width: "25%" }}
                    margin="dense"
                    value={values.region}
                    onChange={handleValue("region")}
                    label={intl.formatMessage(form.region)}
                    disabled={values.country != "it"}
                    select
                  >
                    <MenuItem key="region-empty" value="">
                      -
                    </MenuItem>
                    {[...new Set(Object.values(provinces))]
                      .sort()
                      .map((val) => (
                        <MenuItem key={val} value={val}>
                          {val}
                        </MenuItem>
                      ))}
                  </TextField>

                  <TextField
                    style={{ width: "25%" }}
                    margin="dense"
                    value={values.province}
                    onChange={handleValue("province")}
                    label={intl.formatMessage(form.province)}
                    disabled={values.country != "it"}
                    select
                  >
                    <MenuItem key="province-empty" value="">
                      -
                    </MenuItem>
                    {Object.entries(provinces)
                      .filter((key) => key.includes(values.region))
                      .sort()
                      .map(([key, value]) => (
                        <MenuItem key={key + value} value={key}>
                          {key}
                        </MenuItem>
                      ))}
                  </TextField>

                  <TextField
                    style={{ width: "25%" }}
                    margin="dense"
                    fullWidth
                    label={intl.formatMessage(form.city)}
                    onChange={handleValue("city")}
                    value={values.city}
                  />
                </Box>
                <Box>
                  <TimePicker
                    label={intl.formatMessage(ecommerce.arrivalTime)}
                    value={values.arrival_time}
                    style={{ width: "25%" }}
                    onChange={handleValue("arrival_time")}
                    clearable
                  />
                  <TextField
                    margin="normal"
                    style={{ width: "75%" }}
                    label={intl.formatMessage(ecommerce.referrerPerson)}
                    onChange={handleValue("referrer_person")}
                    value={values.referrer_person}
                  />
                </Box>
                <Box>
                  <TextField
                    margin="normal"
                    style={{ width: "33%" }}
                    label={intl.formatMessage(ecommerce.pullmanNumber)}
                    onChange={handleValue("pullman_number")}
                    value={values.pullman_number}
                  />
                  <TextField
                    margin="normal"
                    style={{ width: "33%" }}
                    label={intl.formatMessage(ecommerce.pullmanLength)}
                    onChange={handleValue("pullman_length")}
                    value={values.pullman_length}
                  />
                  <TextField
                    margin="normal"
                    style={{ width: "34%" }}
                    label={intl.formatMessage(ecommerce.participantsNumber)}
                    onChange={handleValue("participantsNumber")}
                    value={values.participantsNumber}
                  />
                </Box>
                <TextField
                  margin="normal"
                  fullWidth
                  label={intl.formatMessage(common.mobile)}
                  onChange={handleValue("mobile")}
                  value={values.mobile}
                />
                {values.id == null ? (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={values.to_confirm}
                        onChange={handleValue("to_confirm")}
                        color="primary"
                      />
                    }
                    label={intl.formatMessage(ecommerce.toConfirm)}
                  />
                ) : null}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.survivor}
                      onChange={handleValue("survivor")}
                      color="primary"
                    />
                  }
                  label={intl.formatMessage(ecommerce.survivor)}
                />

                <TextareaAutosize
                  style={{ marginTop: "10px", width: "100%", height: "80px" }}
                  fullWidth
                  name="notes"
                  value={values.notes}
                  onChange={handleValue("notes")}
                  placeholder={intl.formatMessage(common.notes)}
                />
              </Box>
            ) : (
              ""
            )}

            <DialogActions>
              <Button
                variant="outlined"
                onClick={() => {
                  setOpen(false);
                }}
              >
                {intl.formatMessage(common.cancel)}
              </Button>
              {values.period != null ? (
                <Button
                  type="button"
                  variant="contained"
                  onClick={() =>
                    values.id == null ? addReservations() : editReservations()
                  }
                  color="primary"
                >
                  {intl.formatMessage(common.confirm)}
                </Button>
              ) : null}
            </DialogActions>
          </DialogContent>
        </form>
      </Dialog>

      <Box display="flex" flexDirection={smallScreen ? "column" : "row"}>
        <TextField
          margin="dense"
          value={filters.status}
          fullWidth
          onChange={handleFilters("status")}
          label={intl.formatMessage(ecommerce.status)}
          select
          InputLabelProps={{
            shrink: true,
          }}
        >
          {Array.from(RESERVATIONS_STATUS).map(([key, value]) => (
            <MenuItem key={key} value={key}>
              {intl.formatMessage(value)}
            </MenuItem>
          ))}
        </TextField>

        <DatePicker
          margin="dense"
          fullWidth
          onChange={handleFilters("from")}
          label={intl.formatMessage(common.reservationFrom)}
          value={filters.from}
          format="dd/MM/yy"
          renderInput={(params) => <TextField {...params} />}
          clearable
        />

        <DatePicker
          margin="dense"
          fullWidth
          onChange={handleFilters("to")}
          label={intl.formatMessage(common.to)}
          value={filters.to}
          format="dd/MM/yy"
          renderInput={(params) => <TextField {...params} />}
          clearable
        />
        <DatePicker
          margin="dense"
          fullWidth
          onChange={handleFilters("created_at_from")}
          label={intl.formatMessage(common.requestFrom)}
          value={filters.created_at_from}
          format="dd/MM/yy"
          renderInput={(params) => <TextField {...params} />}
          clearable
        />
        <DatePicker
          margin="dense"
          fullWidth
          onChange={handleFilters("created_at_to")}
          label={intl.formatMessage(common.to)}
          value={filters.created_at_to}
          format="dd/MM/yy"
          renderInput={(params) => <TextField {...params} />}
          clearable
        />
      </Box>
      <Box display="flex" flexDirection={smallScreen ? "column" : "row"}>
        <TextField
          margin="dense"
          fullWidth
          label={intl.formatMessage(common.contactPerson)}
          onChange={handleFilters("referrer")}
          value={filters.referrer}
        />
        <TextField
          margin="dense"
          value={filters.country}
          onChange={handleFilters("country")}
          label={intl.formatMessage(common.country)}
          select
          fullWidth
        >
          <MenuItem key="filter-country-empty" value="">
            -
          </MenuItem>
          {countries?.sort().map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.str_value}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          margin="dense"
          value={filters.country != "it" ? null : filters.region}
          fullWidth
          onChange={handleFilters("region")}
          label={intl.formatMessage(form.region)}
          disabled={filters.country != "it"}
          select
        >
          <MenuItem key="filter-region-empty" value="">
            -
          </MenuItem>
          {[...new Set(Object.values(provinces))].sort().map((val) => (
            <MenuItem key={val} value={val}>
              {val}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          margin="dense"
          value={filters.province}
          fullWidth
          onChange={handleFilters("province")}
          label={intl.formatMessage(form.province)}
          disabled={filters.country != "it"}
          select
        >
          <MenuItem key="filter-province-empty" value="">
            -
          </MenuItem>
          {Object.entries(provinces)
            .filter((key) => key.includes(filters.region))
            .sort()
            .map(([key, value]) => (
              <MenuItem key={key} value={value}>
                {key}
              </MenuItem>
            ))}
        </TextField>

        <TextField
          margin="dense"
          value={filters.visitorType_filter}
          fullWidth
          onChange={handleFilters("visitorType_filter")}
          label={intl.formatMessage(ecommerce.visitorType)}
          select
        >
          <MenuItem key="filter-visitor-type-empty" value="">
            -
          </MenuItem>
          {Object.entries(RESERVATIONS_VISITOR_TYPES_RESTRICTED).map(
            ([key, value]) => (
              <MenuItem key={key} value={key}>
                {intl.formatMessage(value)}
              </MenuItem>
            )
          )}
        </TextField>
      </Box>
      <Box style={{ marginTop: "10px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={searchReservations}
          style={{ marginRight: "10px" }}
        >
          {intl.formatMessage(common.search)}
        </Button>
        <Button variant="outlined" color="primary" onClick={cleanFilters}>
          Pulisci filtri
        </Button>
      </Box>

      {!smallScreen && (
        <Box mt={2}>
          <Card>
            <CardContent>
              <TableContainer>
                <Table padding="none">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        padding="checkbox"
                        className={classes.headerCheckbox}
                      >
                        <Checkbox
                          indeterminate={
                            selection.length > 0 &&
                            selection.length < reservations.length
                          }
                          checked={
                            reservations.length > 0 &&
                            selection.length === reservations.length
                          }
                          onChange={(e) => toggleSelectionAll(e.target.checked)}
                        />
                      </TableCell>

                      <TableCell />
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => sortBy("status")}
                      >
                        {intl.formatMessage(common.status)}
                        {getSortIcon("status")}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => sortBy("date")}
                      >
                        {intl.formatMessage(common.dateAndTimeReservationShort)}{" "}
                        {getSortIcon("date")}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => sortBy("created_at")}
                      >
                        {intl.formatMessage(common.dateAndTimeRequestShort)}
                        {getSortIcon("created_at")}
                      </TableCell>
                      <TableCell className={classes.colNotSortable}>
                        {intl.formatMessage(ecommerce.arrivalTime)}
                      </TableCell>
                      <TableCell className={classes.colNotSortable}>
                        {intl.formatMessage(ecommerce.survivorShort)}
                      </TableCell>
                      <TableCell className={classes.colNotSortable}>
                        {intl.formatMessage(ecommerce.visitorType)}
                      </TableCell>
                      <TableCell className={classes.colNotSortable}>
                        {intl.formatMessage(ecommerce.participantsNumberShort)}
                      </TableCell>
                      <TableCell className={classes.colNotSortable}>
                        {intl.formatMessage(form.city)}
                      </TableCell>
                      <TableCell className={classes.colNotSortable}>
                        {intl.formatMessage(form.province)}
                      </TableCell>
                      <TableCell className={classes.colNotSortable}>
                        {intl.formatMessage(form.region)}
                      </TableCell>
                      <TableCell className={classes.colNotSortable}>
                        {intl.formatMessage(common.country)}
                      </TableCell>
                      <TableCell className={classes.colNotSortable}></TableCell>
                    </TableRow>
                  </TableHead>

                  {sortedReservations.map((r, index) => {
                    const {
                      attrs,
                      visitorType,
                      visitLang,
                    } = renderReservationDetails(r);

                    const plannedDeliveryDate = new Date(r.planned_delivery);
                    const isPastReservation = plannedDeliveryDate < today;

                    return (
                      <TableBody key={r.id}>
                        <TableRow
                          className={`${classes.root} ${
                            r.status == 0 ? classes.rowToBeConfirmed : ""
                          }`}
                          style={
                            isPastReservation
                              ? { background: "#f2f2f2" }
                              : undefined
                          }
                        >
                          <TableCell
                            padding="checkbox"
                            className={classes.rowCheckbox}
                            align="center"
                          >
                            <Checkbox
                              edge="start"
                              checked={selection.some(
                                (item) => item.id === r.id
                              )}
                              onChange={() => handleSelection(r)}
                              color="primary"
                              disabled={isPastReservation}
                            />
                          </TableCell>

                          <TableCell padding="none">
                            <IconButton
                              hidden
                              aria-label="expand row"
                              size="small"
                              onClick={() => handleToggleRow(index)}
                              disabled={false}
                            >
                              {openRows[index] ? (
                                <KeyboardArrowUp />
                              ) : (
                                <KeyboardArrowDown />
                              )}
                            </IconButton>
                          </TableCell>

                          <TableCell padding="none">
                            {getStatusLabel(r.status, intl)}
                          </TableCell>

                          <TableCell padding="none">
                            <Typography>
                              {format(plannedDeliveryDate, "dd/MM/yy HH.mm")}
                            </Typography>
                          </TableCell>

                          <TableCell padding="none">
                            <Typography>
                              {format(new Date(r.created_at), "dd/MM/yy HH.mm")}
                            </Typography>
                          </TableCell>

                          <TableCell padding="none">
                            {attrs["arrival_time"]}
                          </TableCell>

                          <TableCell padding="none">
                            {getSurvirorLabel(attrs["survivor"])}
                          </TableCell>

                          <TableCell padding="none">{visitorType}</TableCell>
                          <TableCell padding="none">
                            {attrs["group_number"]}
                          </TableCell>
                          <TableCell padding="none">{attrs["city"]}</TableCell>
                          <TableCell padding="none">
                            {attrs["province"]}
                          </TableCell>
                          <TableCell padding="none">
                            {attrs["regione"]}
                          </TableCell>
                          <TableCell padding="none">
                            {getCountryLabel(attrs["country"])}
                          </TableCell>
                          {/*
                          <TableCell padding="none">{visitLang}</TableCell>
                          <TableCell padding="none">
                            {r.mobile && (
                              <Link
                                onClick={() =>
                                  window.open("tel:" + r.mobile, "_blank")
                                }
                                style={{
                                  cursor: "pointer",
                                  color: "black",
                                  textDecoration: "underline",
                                }}
                              >
                                {r.mobile}
                              </Link>
                            )}
                          </TableCell>
                          <TableCell padding="none">
                            {r.email && (
                              <Link
                                style={{
                                  color: "black",
                                  textDecoration: "underline",
                                }}
                                href={`mailto:${r.email}`}
                              >
                                {r.email}
                              </Link>
                            )}
                          </TableCell>
                          */}
                          <TableCell padding="none">
                            <IconButton onClick={(e) => handleClick(e, r)}>
                              <MoreVert />
                            </IconButton>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell
                            style={{
                              paddingBottom: 0,
                              paddingTop: 0,
                            }}
                            colSpan={13}
                          >
                            <Collapse
                              in={openRows[index]}
                              timeout="auto"
                              unmountOnExit
                            >
                              <Box margin={1}>
                                {r.mobile != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(common.mobile) +
                                      ": " +
                                      r.mobile}
                                  </Typography>
                                ) : null}
                                {r.email != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(common.email)}:
                                    <Link
                                      style={{
                                        color: "black",
                                        textDecoration: "underline",
                                      }}
                                      href={`mailto:${r.email}`}
                                    >
                                      {r.email}
                                    </Link>
                                  </Typography>
                                ) : null}
                                {attrs["group_name"] != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(
                                      ecommerce.visitorGroupName
                                    ) +
                                      ": " +
                                      attrs["group_name"]}
                                  </Typography>
                                ) : null}
                                {attrs["pullman_number"] != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(
                                      ecommerce.pullmanNumber
                                    )}
                                    :{attrs["pullman_number"]}
                                  </Typography>
                                ) : null}
                                {attrs["pullman_length"] != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(
                                      ecommerce.pullmanLength
                                    )}
                                    :{attrs["pullman_length"]}
                                  </Typography>
                                ) : null}
                                {visitLang != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(
                                      ecommerce.visitLanguage
                                    ) +
                                      ": " +
                                      visitLang}
                                  </Typography>
                                ) : null}
                                {r.notes != "" ? (
                                  <Typography>
                                    {intl.formatMessage(common.notes) +
                                      ": " +
                                      r.notes}
                                  </Typography>
                                ) : null}
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    );
                  })}
                </Table>
              </TableContainer>
              <CardActions className={classes.cardActionsRight}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={askConfirmReservations}
                  disabled={!selection?.length}
                >
                  {intl.formatMessage(common.confirm)}
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={askCancelReservations}
                  disabled={!selection?.length}
                >
                  {intl.formatMessage(common.cancel)}
                </Button>
              </CardActions>
            </CardContent>
          </Card>
        </Box>
      )}

      {smallScreen && (
        <Box mt={2}>
          <Card>
            <CardContent>
              <Box display="flex" alignItems="center">
                <Checkbox
                  indeterminate={
                    selection.length > 0 &&
                    selection.length < reservations.length
                  }
                  checked={
                    reservations.length > 0 &&
                    selection.length === reservations.length
                  }
                  onChange={(e) => toggleSelectionAll(e.target.checked)}
                />

                <Typography>
                  {intl.formatMessage(common.selectDeselectAll)}
                </Typography>
              </Box>

              <List>
                {reservations
                  .sort((a, b) => a.date - b.date)
                  .map((r, index) => {
                    const {
                      attrs,
                      visitorType,
                      visitLang,
                    } = renderReservationDetails(r);

                    const plannedDeliveryDate = new Date(r.planned_delivery);
                    const isPastReservation = plannedDeliveryDate < today;

                    return (
                      <React.Fragment key={r.id}>
                        {index !== 0 && <Divider component="li" />}

                        <ListItem
                          style={{
                            background: isPastReservation
                              ? "#f2f2f2"
                              : "inherit",
                          }}
                        >
                          <ListItemText
                            primary={
                              <React.Fragment>
                                <Box display="flex" alignItems="center">
                                  <Checkbox
                                    edge="start"
                                    checked={selection.some(
                                      (item) => item.id === r.id
                                    )}
                                    onChange={() => handleSelection(r)}
                                    color="primary"
                                    disabled={isPastReservation}
                                  />

                                  <Typography style={{ fontWeight: 700 }}>
                                    {checkClosingDates(r.planned_delivery) && (
                                      <Tooltip title="La data della prenotazione coincide con un giorno di chiusura.">
                                        <Warning
                                          style={{ marginRight: 5 }}
                                          color="primary"
                                        />
                                      </Tooltip>
                                    )}

                                    {format(
                                      plannedDeliveryDate,
                                      "EEEE dd MMMM | HH:mm",
                                      {
                                        locale: it,
                                      }
                                    )}
                                  </Typography>
                                </Box>

                                <Typography style={{ fontWeight: 700 }}>
                                  {intl.formatMessage(common.details)}
                                </Typography>

                                <Typography>{`${intl.formatMessage(
                                  ecommerce.status
                                )}: ${getStatusLabel(
                                  r.status,
                                  intl
                                )}`}</Typography>

                                <Typography>{`${intl.formatMessage(
                                  ecommerce.visitorType
                                )}: ${visitorType}`}</Typography>

                                <Typography>{`${intl.formatMessage(
                                  ecommerce.visitorGroupName
                                )}: ${attrs["group_name"] || ""}`}</Typography>

                                <Typography>{`${intl.formatMessage(
                                  ecommerce.participantsNumber
                                )}: ${
                                  attrs["group_number"] || ""
                                }`}</Typography>

                                {attrs["arrival_time"] != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(ecommerce.arrivalTime)}
                                    {attrs["arrival_time"]}
                                  </Typography>
                                ) : null}

                                {attrs["pullman_number"] != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(
                                      ecommerce.pullmanNumber
                                    )}
                                    {attrs["pullman_number"]}
                                  </Typography>
                                ) : null}

                                {attrs["pullman_length"] != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(
                                      ecommerce.pullmanLength
                                    )}
                                    {attrs["pullman_length"]}
                                  </Typography>
                                ) : null}

                                <Typography>{`${intl.formatMessage(
                                  ecommerce.visitLanguage
                                )}: ${visitLang}`}</Typography>

                                <Typography>{`${intl.formatMessage(
                                  ecommerce.visitorGroupName
                                )}: ${attrs["group_name"]}`}</Typography>

                                <Typography>
                                  {intl.formatMessage(ecommerce.survivor)}
                                  {getSurvirorLabel(attrs["survivor"])}
                                </Typography>

                                {attrs["country"] != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(common.country)}
                                    {"Stato: " +
                                      getCountryLabel(attrs["country"])}
                                  </Typography>
                                ) : null}
                                {attrs["region"] != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(common.region)}
                                    {attrs["region"]}
                                  </Typography>
                                ) : null}
                                {attrs["province"] != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(common.province)}
                                    {attrs["province"]}
                                  </Typography>
                                ) : null}
                                {attrs["city"] != undefined ? (
                                  <Typography>
                                    {intl.formatMessage(form.city)}
                                    {attrs["city"]}
                                  </Typography>
                                ) : null}

                                <Typography>
                                  {r.mobile && (
                                    <Link
                                      onClick={() =>
                                        window.open("tel:" + r.mobile, "_blank")
                                      }
                                      style={{
                                        cursor: "pointer",
                                        color: "black",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      {r.mobile}
                                    </Link>
                                  )}

                                  {r.mobile && r.email && " - "}

                                  {r.email && (
                                    <Link
                                      style={{
                                        color: "black",
                                        textDecoration: "underline",
                                      }}
                                      href={`mailto:${r.email}`}
                                    >
                                      {r.email}
                                    </Link>
                                  )}
                                </Typography>

                                {r.notes && (
                                  <>
                                    <Typography>
                                      <Link
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleToggleNotes(index)}
                                      >
                                        {!openNotes[index]
                                          ? "Mostra note"
                                          : "Nascondi note"}
                                      </Link>
                                    </Typography>

                                    <Typography>
                                      {openNotes[index] && r.notes}
                                    </Typography>
                                  </>
                                )}
                              </React.Fragment>
                            }
                          />
                        </ListItem>
                      </React.Fragment>
                    );
                  })}
              </List>
            </CardContent>
          </Card>
        </Box>
      )}

      <Menu
        key={reservationSelected}
        anchorEl={anchorEl}
        keepMounted
        open={!!anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setReservationSelected(null);
        }}
        onClick={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setEditReservations(reservationSelected);
          }}
        >
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">
            {intl.formatMessage(common.modify)}
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={askConfirmReservations}
          disabled={new Date(reservationSelected?.planned_delivery) < today}
        >
          <ListItemIcon>
            <Check fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">
            {intl.formatMessage(common.confirm)}
          </Typography>
        </MenuItem>
      </Menu>

      <FloatingActions>
        <Fab variant="extended" color="primary" onClick={openAddModal}>
          <Add />
          {intl.formatMessage(common.add)}
        </Fab>
      </FloatingActions>
    </Container>
  );
}
